(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('HistoricoAlteracoeService', HistoricoAlteracoeService);

  HistoricoAlteracoeService.$inject = [
    '$http'
  ];

  function HistoricoAlteracoeService($http) {
    const service = {
      list
    };
    return service;

    function list(params) {
      return $http.get(`${SERVER}v1/historicos_alteracoes`, { params });
    }
  }
}());
